/**
 * Labstep
 *
 * @module components/Organization/Form/Create
 * @desc Organization Form Create
 */

import { fieldOrganizationName } from 'labstep-web/components/Organization/Form/fields';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import { Organization } from 'labstep-web/models/organization.model';
import type React from 'react';
import type { OrganizationFormCreateProps } from './types';

export const OrganizationFormCreate: React.FC<
  OrganizationFormCreateProps
> = (props) => (
  <FormCreate
    autoFocus
    entityName={Organization.entityName}
    fields={[fieldOrganizationName]}
    {...props}
  />
);
